// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"d4f5f319","291":"3627d6b8","372":"1653389f","494":"3dda2b96","787":"865e6ded"}[chunkId] + ".chunk.js";
};